import Rust from './rust';

export default Rust;
